export default {"src":"/_next/static/media/HKD.e83e94cf.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};